import AbstractForecastColumn from "../instance/AbstractForecastColumn.js";

/**
 * This column is used to handle an expired period. It is used on
 * RuleTemplateInheritingCache for instance.
 *
 * @param {RuleTemplate[]} ruleTemplates - The array of RuleTemplate origin of the column.
 */
export default class ExpiredForecastColumn extends AbstractForecastColumn {
	constructor({ ruleTemplates }) {
		super(...arguments);

		this._ruleTemplates = ruleTemplates;
	}

	getRuleTemplate({ row }) {
		return this._ruleTemplates.find(
			(ruleTemplate) => ruleTemplate.getRowId() === row.getStableId(),
		);
	}
}
